import { t } from "@/i18n-js/instance";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { IconType } from "@circle-react-shared/Icon";
import { defaultData as p1DefaultData } from "../P1BlockDefaultData";
import { defaultData as p2DefaultData } from "../P2BlockDefaultData";
import { defaultData as p3DefaultData } from "../P3BlockDefaultData";

export const FONT_STYLE_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.font_style_types.normal"),
    value: "normal",
  },
  {
    label: t("builder_ui.prop_type.styles.font_style_types.italic"),
    value: "italic",
  },
  {
    label: t("builder_ui.prop_type.styles.font_style_types.oblique"),
    value: "oblique",
  },
];

export const FONT_WEIGHT_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.normal"),
    value: "400",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.medium"),
    value: "500",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.semibold"),
    value: "600",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.bold"),
    value: "700",
  },
];

export const TEXT_DECORATION_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.none"),
    value: "none",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.underline"),
    value: "underline",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.overline"),
    value: "overline",
  },
  {
    label: t("builder_ui.prop_type.styles.text_decoration_types.line_through"),
    value: "line-through",
  },
];

export const TEXT_TRANSFORM_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.none"),
    value: "none",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.uppercase"),
    value: "uppercase",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.lowercase"),
    value: "lowercase",
  },
  {
    label: t("builder_ui.prop_type.styles.text_transform_types.capitalize"),
    value: "capitalize",
  },
];

interface TextAlignOption {
  icon: IconType;
  type: "left" | "center" | "right" | "justify";
}

export const TEXT_ALIGN_OPTIONS: TextAlignOption[] = [
  {
    type: "left",
    icon: "20-builder-ui-style-text-align-left",
  },
  {
    type: "center",
    icon: "20-builder-ui-style-text-align-center",
  },
  {
    type: "right",
    icon: "20-builder-ui-style-text-align-right",
  },
  {
    type: "justify",
    icon: "20-builder-ui-style-text-align-justify",
  },
];

export const PARAGRAPH_STYLES = ["p1", "p2", "p3"] as const;
export type ParagraphStyle = (typeof PARAGRAPH_STYLES)[number];

export const PARAGRAPH_DEFAULT_DATA: Readonly<
  Record<ParagraphStyle, BaseBlock>
> = {
  p1: p1DefaultData,
  p2: p2DefaultData,
  p3: p3DefaultData,
};

export const TEXT_SELECT_OPTIONS = PARAGRAPH_STYLES.map(style => ({
  value: style,
  label: t(`builder_ui.block_type.${style}`),
}));
